import { IsNotEmpty, IsString, IsUUID } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

export class CreateSubjectTypeDto {
  @ApiProperty({
    type: 'string',
    description: 'ID du type de matière (UUID)',
    example: '4d2e0d1f-7feb-4adc-80fe-dc2c5263fd31',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({ type: 'string', description: 'Code du type de matière', example: 'SCIENCES' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({
    type: 'string',
    description: 'Libellé du type de matière',
    example: 'Sciences',
  })
  @IsNotEmpty()
  @IsString()
  label!: string
}
